import React, { useEffect, useId, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Datepicker } from 'flowbite-datepicker';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

type DateInputProps = {
  placeholder?: string;
  className?: string;
  defaultValue?: Dayjs;
  onChange?: (value?: Dayjs) => void;
  disabled?: boolean;
  inputClassNames?: string;
};

const DateInput: React.FC<DateInputProps> = (props) => {
  const { onChange, disabled } = props;
  const [date, setDate] = useState<Dayjs | undefined>(
    props.defaultValue ?? undefined,
  );

  const id = useId();
  useEffect(() => {
    const datepickerEl = document.getElementById(id);
    // eslint-disable-next-line no-new
    const datePicker = new Datepicker(datepickerEl, {
      disableTouchKeyboard: true,
      format: 'dd/mm/yyyy',
    });

    const updateDate = (e: { detail: { date: Date } }) => {
      setDate(e.detail.date ? dayjs(e.detail.date) : undefined);
    };
    datePicker.element.addEventListener('changeDate', updateDate);

    return () => {
      datePicker.element.removeEventListener('changeDate', updateDate);
    };
  }, [id]);

  useEffect(() => {
    onChange?.(date);
  }, [date, onChange]);

  const inputClassNames = twMerge(
    'outline-none bg-gray-50 text-gray-900 sm:text-sm rounded focus:ring-blue-500 focus:border-blue-500 border border-gray100',
    'block w-full p-2.5',
    disabled && 'bg-gray100 text-gray100',
    props.inputClassNames,
  );

  return (
    <div className={twMerge('relative bg-white rounded', props.className)}>
      <input
        id={id}
        // @ts-expect-error non standard
        // eslint-disable-next-line react/no-unknown-property
        datepicker="true"
        // eslint-disable-next-line react/no-unknown-property
        datepicker-autohide="true"
        type="text"
        className={inputClassNames}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue?.format('DD/MM/YYYY') ?? undefined}
        disabled={disabled}
      />
    </div>
  );
};

export default DateInput;
